import script from "./MetasFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetasFormView.vue?vue&type=script&setup=true&lang=js"

import "./MetasFormView.vue?vue&type=style&index=0&id=09abcaae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09abcaae"]])

export default __exports__